import { SnotifyService, SnotifyPosition } from 'ng-snotify';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { LogIn } from '../_models/log-in';
import { ForgotPasswordService } from '../_services/forgot-password.service';
import swal from 'sweetalert2';
import { Router } from '@angular/router';


@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {

  resetPasswordFormGroup: FormGroup;
  logInDataForm: LogIn = new LogIn();
  public isLoading: boolean = false;


  constructor(private forgotPasswordService:ForgotPasswordService,
    private formbuilder: FormBuilder,
    private router : Router,
    private snotifyService: SnotifyService
    ) { }

  ngOnInit() {
    this.emailIdValidator();
  }

  emailIdValidator() {
    // const mobnumPattern = "^[0-9+]*$";
    // const namePattern = "^[A-Za-z\\s-]+$";
    // const emailPattern = "[[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$";
    this.resetPasswordFormGroup = this.formbuilder.group({
      email: ['', [Validators.nullValidator]],

    });

  }

  sendPasswordResetLink(){

  if (this.resetPasswordFormGroup.valid) {
    this.isLoading = true;
    this.logInDataForm.email = this.resetPasswordFormGroup.get('email').value;
    console.log("EMAIL ID : "+this.logInDataForm.email);
    this.forgotPasswordService.forgotPassword(this.logInDataForm).subscribe(resp=>{
   this.isLoading = false;
      if (resp.status == 200) {
        let msg = "Email sent successfully!";
        let action = ''
        this.snotifyService.success(msg, action, {
          timeout: 3000,
          showProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          position: SnotifyPosition.rightBottom
        })
        this.router.navigate(['/login'])
      }
      else {
        //this.loading = false;
        let msg = "Something went wrong!";
        let action = ''
        this.snotifyService.error(msg, action, {
          timeout: 3000,
          showProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          position: SnotifyPosition.rightBottom
        })
      }
    }, (error : any) =>{
      //this.loading = false;
        let msg = "Something Went Wrong"
        let action = ''
        this.snotifyService.error(msg, action, {
          timeout: 3000,
          showProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          position: SnotifyPosition.rightBottom
        })
    })}
    
  }
  

}
